<div class="results-container">
  <!-- Summary / Selection Toolbar -->
  <div
    class="toolbar"
    [class.selection-active]="selection.hasValue()">
    <div
      *ngIf="!selection.hasValue(); else selectionMode"
      class="fx-row fx-jc-start fx-ai-center"
      fxFlex>
      <span
        class="summary-text"
        *ngIf="studies?.length">
        Showing {{ studies.length }} results
        <span *ngIf="activeFiltersDescription"> | Filters: {{ activeFiltersDescription }}</span>
      </span>
      <span
        *ngIf="!studies?.length && !isLoading"
        class="summary-text"
        >No studies found.</span
      >
    </div>

    <ng-template #selectionMode>
      <div
        class="fx-row fx-jc-start fx-ai-center fx-gap-16"
        fxFlex>
        <span class="selection-count">Selected: {{ selection.selected.length }}</span>

        <button
          *ngIf="showViewDownloadActions"
          mat-raised-button
          color="accent"
          (click)="onDownloadSelected()">
          <mat-icon>download</mat-icon> Download Selected
        </button>

        <!-- Dialog mode: single button, opens target+modality dialog -->
        <button
          *ngIf="showSendAction && showSendDialog"
          mat-raised-button
          color="primary"
          (click)="onSendMultipleDialog()">
          <mat-icon>send</mat-icon> Send Selected…
        </button>

        <!-- Normal mode: pre-selected target, show modality menu -->
        <button
          *ngIf="showSendAction && !showSendDialog && availableModalities.length === 1"
          mat-raised-button
          color="primary"
          (click)="onSendMultipleSelected(availableModalities[0].name)">
          <mat-icon>send</mat-icon> Send Selected
        </button>
        <button
          *ngIf="showSendAction && !showSendDialog && availableModalities.length !== 1"
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="sendSelectedMenu">
          <mat-icon>send</mat-icon> Send Selected
        </button>
        <mat-menu #sendSelectedMenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let modality of availableModalities"
            (click)="onSendMultipleSelected(modality.name)">
            <mat-icon>send</mat-icon>
            <span>Send to {{ modality.aet || modality.name }}</span>
          </button>
        </mat-menu>

        <button
          mat-raised-button
          color="warn"
          (click)="onDeleteSelected()">
          <mat-icon>delete</mat-icon> Delete Selected
        </button>

        <button
          mat-button
          (click)="onClearSelection()">
          Clear Selection
        </button>
      </div>
    </ng-template>

    <!-- Optional: Pagination Controls in Top Bar? No, keep bottom. -->
  </div>

  <div class="table-wrapper mat-elevation-z2">
    <mat-progress-bar
      mode="indeterminate"
      *ngIf="isLoading"></mat-progress-bar>

    <table
      mat-table
      matSort
      [dataSource]="dataSource"
      multiTemplateDataRows>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          (click)="$event.stopPropagation()">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Study Date -->
      <ng-container matColumnDef="studyDate">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef>
          Study Date
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.studyDate }}
          <app-study-share-status-badge
            *ngIf="isSpokeUser && shareMap[element.studyInstanceUid]"
            [share]="shareMap[element.studyInstanceUid]"
            class="inline-expiry-badge">
          </app-study-share-status-badge>
          <span *ngIf="!isSpokeUser && hubShareMap[element.studyInstanceUid]"
                class="inline-hub-share-age">
            {{ formatHubShareAge(element) }}
          </span>
        </td>
      </ng-container>

      <!-- Patient Name -->
      <ng-container matColumnDef="patientName">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef>
          Patient Name
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.patientName }}
        </td>
      </ng-container>

      <!-- Patient ID -->
      <ng-container matColumnDef="patientId">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef>
          Patient ID
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          <span
            *ngIf="element.patientId; else noPatientId"
            class="patient-id-chip"
            matTooltip="Filter by this Patient ID"
            (click)="$event.stopPropagation(); filterByPatientId.emit(element.patientId)">
            {{ element.patientId }}
          </span>
          <ng-template #noPatientId>—</ng-template>
        </td>
      </ng-container>

      <!-- Accession -->
      <ng-container matColumnDef="accessionNumber">
        <th
          mat-header-cell
          mat-sort-header
          *matHeaderCellDef>
          Accession
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.accessionNumber }}
        </td>
      </ng-container>

      <!-- Modalities -->
      <!-- <ng-container matColumnDef="modalities">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Modalities
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          <mat-chip-set>
            <mat-chip
              *ngFor="let m of element.modalitiesInStudy"
              class="micro-chip"
              >{{ m }}</mat-chip
            >
          </mat-chip-set>
        </td>
      </ng-container> -->

      <!-- Instances -->
      <ng-container matColumnDef="instances">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Series / Inst.
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.seriesCount || 0 }} / {{ element.instanceCount || 0 }}
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Actions
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="actions-cell">
          <div class="action-buttons">
            <button
              *ngIf="showViewDownloadActions"
              mat-icon-button
              color="primary"
              [matTooltip]="isShareExpired(element) ? 'Study has expired and is no longer available' : 'View study'"
              [disabled]="isShareExpired(element)"
              (click)="onViewSingle($event, element)"
              class="action-button">
              <mat-icon>visibility</mat-icon>
            </button>
            <button
              *ngIf="showViewDownloadActions"
              mat-icon-button
              color="primary"
              [matTooltip]="isShareExpired(element) ? 'Study has expired and is no longer available' : 'Download Study'"
              [disabled]="isShareExpired(element)"
              (click)="onDownloadSingle($event, element)"
              class="action-button">
              <mat-icon>download</mat-icon>
            </button>

            <!-- Mark as Uploaded to PACS — Spoke users only -->
            <button
              *ngIf="isSpokeUser && shareMap[element.studyInstanceUid]"
              mat-icon-button
              [matTooltip]="isUploadedToPacs(element) ? 'Uploaded to PACS' : 'Mark as Uploaded to PACS'"
              [disabled]="isUploadedToPacs(element) || (shareMap[element.studyInstanceUid] && pendingMarkDoneIds.has(shareMap[element.studyInstanceUid]!.id))"
              [style.color]="isUploadedToPacs(element) ? '#00695c' : null"
              (click)="onMarkDone($event, element)"
              class="action-button">
              <mat-icon>{{ isUploadedToPacs(element) ? 'cloud_done' : 'check_circle_outline' }}</mat-icon>
            </button>

            <button
              *ngIf="patientExistsMap[element.patientId] === false && !isSpokeUser"
              mat-icon-button
              color="primary"
              matTooltip="Add Patient"
              (click)="onAddPatient($event, element)"
              class="action-button">
              <mat-icon>person_add</mat-icon>
            </button>
            <!-- Dialog mode: single icon button, opens target+modality dialog -->
            <span *ngIf="showSendAction && showSendDialog"
                  style="display:inline-block"
                  [matTooltip]="isShareExpired(element) ? 'Study has expired and is no longer available' : patientExistsMap[element.patientId] === false ? 'Patient must be registered before sending' : 'Select target &amp; send'">
              <button
                mat-icon-button
                [disabled]="isShareExpired(element) || patientExistsMap[element.patientId] === false"
                (click)="onSendStudyDialog($event, element)"
                class="action-button">
                <mat-icon>send</mat-icon>
              </button>
            </span>

            <!-- Normal mode: pre-selected target -->
            <span *ngIf="showSendAction && !showSendDialog && availableModalities.length === 1"
                  style="display:inline-block"
                  [matTooltip]="isShareExpired(element) ? 'Study has expired and is no longer available' : patientExistsMap[element.patientId] === false ? 'Patient must be registered before sending' : 'Send to ' + availableModalities[0].name">
              <button
                mat-icon-button
                [disabled]="isShareExpired(element) || patientExistsMap[element.patientId] === false"
                (click)="onSendStudy($event, element, availableModalities[0].name)"
                class="action-button">
                <mat-icon>send</mat-icon>
              </button>
            </span>
            <span *ngIf="showSendAction && !showSendDialog && availableModalities.length !== 1"
                  style="display:inline-block"
                  [matTooltip]="isShareExpired(element) ? 'Study has expired and is no longer available' : patientExistsMap[element.patientId] === false ? 'Patient must be registered before sending' : 'Send Study'">
              <button
                mat-icon-button
                [disabled]="isShareExpired(element) || patientExistsMap[element.patientId] === false"
                [matMenuTriggerFor]="isShareExpired(element) || patientExistsMap[element.patientId] === false ? null : sendMenu"
                (click)="$event.stopPropagation()"
                class="action-button">
                <mat-icon>send</mat-icon>
              </button>
            </span>
            <button
              *ngIf="showSendUnavailableHint"
              mat-icon-button
              matTooltip="Why can't I send?"
              (click)="onSendUnavailableClick($event)"
              class="action-button">
              <mat-icon>help_outline</mat-icon>
            </button>
            <mat-menu #sendMenu="matMenu">
              <button
                mat-menu-item
                *ngFor="let modality of availableModalities"
                (click)="onSendStudy($event, element, modality.name)">
                <mat-icon>send</mat-icon>
                <span>Send to {{ modality.aet || modality.name }}</span>
              </button>
              <button
                mat-menu-item
                *ngIf="availableModalities.length === 0"
                disabled>
                <span>No modalities available</span>
              </button>
            </mat-menu>
            <button
              mat-icon-button
              color="warn"
              matTooltip="Delete Study"
              (click)="onDeleteStudy($event, element)"
              class="action-button">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Details Row -->
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length">
          <div
            class="element-detail"
            [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <!-- Detail content -->
            <div class="detail-container fx-col fx-gap-16">
            <!-- Share expiry status — shown for Spoke users when a share record exists -->
            <div *ngIf="shareMap[element.studyInstanceUid]" class="expiry-row">
              <app-study-share-status-badge
                [share]="shareMap[element.studyInstanceUid]">
              </app-study-share-status-badge>
            </div>
            <div class="detail-container fx-row fx-gap-32">
              <!-- Study Information Column -->
              <div
                class="detail-column"
                [style.flex]="isSinglePatient ? '1 1 50%' : '1 1 100%'"
                [style.max-width]="isSinglePatient ? '50%' : '100%'">
                <h3 class="detail-section-title">Study Information</h3>
                <div class="detail-field">
                  <label>Study Date:</label>
                  <span class="detail-value">{{ formatStudyDate(element.studyDate) }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.studyDate || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.studyTime">
                  <label>Study Time:</label>
                  <span class="detail-value">{{ formatStudyTime(element.studyTime) }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.studyTime || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.studyDescription">
                  <label>Study Description:</label>
                  <span class="detail-value">{{ element.studyDescription }}</span>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.accessionNumber">
                  <label>Accession Number:</label>
                  <span class="detail-value">{{ element.accessionNumber }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.accessionNumber || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.studyId !== null && element.studyId !== undefined">
                  <label>Study ID:</label>
                  <span class="detail-value">{{ element.studyId }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(toString(element.studyId), $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div class="detail-field">
                  <label>Study Instance UID:</label>
                  <span class="detail-value mono">{{ element.studyInstanceUid }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.studyInstanceUid, $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.requestingPhysicianName">
                  <label>Requesting Physician:</label>
                  <span class="detail-value">{{ element.requestingPhysicianName }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.requestingPhysicianName || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.referringPhysicianName">
                  <label>Referring Physician Name:</label>
                  <span class="detail-value">{{ element.referringPhysicianName }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.referringPhysicianName || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.institutionName">
                  <label>Hospital Name:</label>
                  <span class="detail-value">{{ element.institutionName }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.institutionName || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Patient Information Column -->
              <div
                *ngIf="isSinglePatient"
                class="detail-column fx-flex-1-1-50">
                <h3 class="detail-section-title">Patient Information</h3>
                <div
                  class="detail-field"
                  *ngIf="element.patientId">
                  <label>Patient ID:</label>
                  <span class="detail-value">{{ element.patientId }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.patientId || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.patientName">
                  <label>Patient Name:</label>
                  <span class="detail-value">{{ formatPatientName(element.patientName) }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.patientName || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.patientBirthDate">
                  <label>Patient Birth Date:</label>
                  <span class="detail-value">{{ formatPatientBirthDate(element.patientBirthDate) }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.patientBirthDate || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.patientSex">
                  <label>Patient Sex:</label>
                  <span class="detail-value">{{ element.patientSex }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.patientSex || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
                <div
                  class="detail-field"
                  *ngIf="element.patientOtherIds">
                  <label>Patient Other IDs:</label>
                  <span class="detail-value">{{ element.patientOtherIds }}</span>
                  <button
                    mat-icon-button
                    class="copy-button"
                    (click)="copyToClipboard(element.patientOtherIds || '', $event)"
                    matTooltip="Copy to clipboard">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            </div><!-- /detail-container fx-col -->
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: displayedColumns"
        class="element-row"
        [class.expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element; rowClick.emit(element)"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"></tr>
    </table>
  </div>

  <!-- Footer Pagination -->
  <div class="pagination-footer fx-row fx-jc-end fx-ai-center fx-gap-16">
    <div class="fx-row fx-jc-start fx-ai-center fx-gap-8">
      <span>Rows per page:</span>
      <mat-form-field
        appearance="fill"
        subscriptSizing="dynamic"
        class="page-size-select">
        <mat-select
          [value]="pageSize"
          (selectionChange)="limitChange.emit($event.value)">
          <mat-option [value]="10">10</mat-option>
          <mat-option [value]="25">25</mat-option>
          <mat-option [value]="50">50</mat-option>
          <mat-option [value]="100">100</mat-option>
          <mat-option [value]="200">200</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="nav-buttons">
      <button
        mat-icon-button
        (click)="previousPage.emit()"
        [disabled]="!hasPreviousPage || isLoading">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="nextPage.emit()"
        [disabled]="!hasNextPage || isLoading">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
